const capitalize = s => {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const getDestinationResource = destinationId => {
  return `/api/v1/destinations/${destinationId}`
}

const snakeToCamel = s => {
  return s.replace(/(_\w)/g, m => {
    return m[1].toUpperCase()
  })
}

export { capitalize, getDestinationResource, snakeToCamel }
